import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { Link } from 'react-scroll';
import { Text } from '../../../shared/components/Text';

const useStyle = makeStyles(theme => ({
  button: {
    color: theme.palette.white,
    marginRight: '25px',
    border: 'none',
    borderRadius: '0',
    '&:hover': {
      border: 'none',
      backgroundColor: 'transparent',
    },
    '&:focus': {
      color: theme.palette.primary.main,
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: '10px',
    },
  },
  text: {
    transition: 'color 0.5s',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

export default function NavbarButton({ to, label }) {
  const classes = useStyle();

  return (
    <Link to={to} smooth duration={700} offset={-120}>
      <Button disableRipple disableFocusRipple className={classes.button}>
        <Text variant="h5" className={classes.text}>
          <Trans>{label}</Trans>
        </Text>
      </Button>
    </Link>
  );
}

NavbarButton.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
